import React, { useState } from 'react';

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, TextField, Grid, Button, FormControl, Select, InputLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const AssignRole = props => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");

  return (
    <div className={classes.paper}>
      <form autoComplete="off" noValidate >
        <Grid container spacing={2}>
          <Grid item xs={12} align="center">
            <TextField name="username" label="Username" variant="outlined" required fullWidth value={username} onChange={(e) => setUsername(e.target.value)} />
          </Grid>
          <Grid item xs={12} align="center">
            <FormControl variant="outlined" fullWidth >
              <InputLabel>User Level</InputLabel>
              <Select native label="User Level" value={role} onChange={(e) => setRole(e.target.value)} >
                <MenuItem aria-label="None" value="" />
                <MenuItem value={0}>Level 0</MenuItem>
                <MenuItem value={1}>Level 1</MenuItem>
                <MenuItem value={2}>Level 2</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} align="center">
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>Submit</Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
};

export default AssignRole;